// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Vytn","footer":"Form_footer__3SD2y"};